import { SoundOutlined, LoopOutlined } from '@landr/maestro';
import { t } from '@lingui/macro';
import { SampleType } from 'types/generated/graphql';

const getIconWithTooltipBySampleType = (type?: SampleType) => {
    switch (type) {
        case SampleType.Loop:
            return {
                Icon: LoopOutlined,
                tooltip: t`Loop`,
            };
        case SampleType.OneShot:
            return {
                Icon: SoundOutlined,
                tooltip: t({
                    id: 'one_shot',
                    message: `One Shot`,
                }),
            };
        default:
            return {
                Icon: null,
                tooltip: '',
            };
    }
};

export default getIconWithTooltipBySampleType;
